import { INameValue } from '@/models/general'
import { convertNameValueToWordCloud } from '@/utils/helper'
import ReactWordcloud, { CallbacksProp, MinMaxPair, OptionsProp } from '@cyberblast/react-wordcloud'

interface WordCloudProps {
  data: INameValue[]
  options?: OptionsProp
  callbacks?: CallbacksProp
}

const defaultOptions: OptionsProp = {
  rotations: 2,
  padding: 3,
  fontSizes: [10, 60] as MinMaxPair,
  rotationAngles: [0, 0] as [number, number],
  deterministic: true,
  spiral: 'archimedean',
  scale: 'linear',
  fontFamily: 'Inter, sans-serif',
  fontStyle: '700',
}

const WordCloud = ({ data, options, callbacks }: WordCloudProps) => {
  const average = useMemo(() => {
    return data.reduce((sum, item) => sum + item.value, 0) / data.length
  }, [data])

  return (
    <ReactWordcloud
      options={{ ...defaultOptions, ...options }}
      words={convertNameValueToWordCloud(data)}
      callbacks={{
        getWordColor: (word: { value: number }) => (word?.value < average * 1.5 ? '#9F9986' : '#382A02'),
        getWordTooltip: (word: { text: string; value: number }) => `${word.text} (${word.value})`,
        ...callbacks,
      }}
    />
  )
}

export default WordCloud
